import styled from "styled-components";

export const MainStyle= styled.div`
    background-color: #f1a9ca;
    border: 1px solid #f1a9ca;
    box-sizing: border-box;
    text-align: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
`

export const DescriptionContainer = styled.div`
    max-width: 1100px;
    font-family: 'GirlOnTheAlley';
    font-size: 1.5rem;
    color: #794b9c;
    @media (max-width: 767px) {
        max-width: 700px;
        font-size: 1.2rem;
    }
`
export const SingleVideo = styled.iframe`
    padding: 10px;
    @media (max-width: 767px) {
        max-width: 80%;
    }
    
`
export const AccentStyle = styled.div`
    background-color: #cbb9d9;
    box-sizing: border-box;
    border: 1px solid #cbb9d9;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const Header1 = styled.h1`
    font-family: 'Kinkee';
    font-size: 4rem;
    color: #794b9c;
    @media (max-width: 767px) {
        
        font-size: 3rem;
    }
`

export const Background = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

export const Gradient = styled.div`
    background: linear-gradient(#f1a9ca, #cbb9d9);
    min-height: 50px;
`
export const OppGradient = styled.div`
    background: linear-gradient(#cbb9d9, #f1a9ca);
    min-height: 50px;
`

export const GeneralLinks = styled.a`
    text-decoration: none;
    color: #794b9c;
    &:active {
        color: #514B9C;
    }
    &:hover {
        color: #9C4B97;
    }
`
export const LinkHeader = styled.h2`
        font-size: 2rem;
     @media (max-width: 767px) {
        
        font-size: 1.7rem;
    }
`
